import {
  Form,
  Row,
  Col,
  Input,
  FormInstance,
  message,
  Select,
  Button,
  DatePicker,
  InputNumber,
} from "antd";
import React, { Component } from "react";
import helper from "../../utils/helper";
import { connect } from "react-redux";
import { stepperMoving, getDataInfo } from "../../stores/actions";
import { getApi, patchApi, request } from '../../../../shared/src/apis';
import moment from "moment";
import { UserInfoUI, MaxInstallmentsWarningModal, DocumentUpload } from '@operations/shared';
import { getCompanyBranchesByCompanyIdApi } from "../../utils/apisConsts";
import { getRegion } from '../../components/regionWrapper';
import { Region } from '../../utils/commonInterfaces';

const { Option } = Select;

interface Props {
  info?: {
    name: string;
    firstName: string;
    middleName: string;
    lastName: string;
    staff_id: string;
    email: string;
    nationalIDNumber: string;
    consent: any;
    nationalId: any;
    hrLetter: any;
    userID: number;
    companyName: string;
    netSalary: number;
    bankAccountHolderName: string
    bankAccountHolderNameEn: string,
    bankAccountNumber: string
    bankName: string;
    phone: string;
    hiringDate: string,
    jobTitle: string,
    companyID: number,
    department: any,
    bankID: number,
    companyBranchID: number | null,
    probationPeriod?: number,
    city?: string,
    userProbationPeriod?: number,
    userMaxInstallments?: number,
    companyMaxInstallmentCount?: number,

  };
  patchApi: any;
  stepperMoving: any;
  getApi: any;
  getDataInfo: any;
  fromViewUserAction: boolean,
  request: any,
}
export class EditUserInfo extends Component<Props> {

  state = {
    imageFile: [],
    // Each document holds either the stored url or the antd fileList once the user touches it
    docs: {
      hrLetter: this.props.info?.hrLetter?.[0] || "",
      consent: this.props.info?.consent?.[0] || "",
      nationalIdFront: this.props.info?.nationalId?.[0] || "",
      nationalIdBack: this.props.info?.nationalId?.[1] || "",
    } as { [key: string]: any },
    sending: false,
    banks: [],
    bankInitialValue: null,
    departments: [],
    companyBranches: [],
    warningModalVisible: false,
    pendingValues: null as any,
  };

  formRef = React.createRef<FormInstance>();
  region = getRegion();
  componentDidMount() {
    this.getBanks()
    this.getCompanyDepartments()
    this.getCompanyBranches()
  }
  getBanks = async () => {
    this.setState({ loadData: true })
    const drops = await this.props.getApi('/users/banks');
    const res = await drops.payload;
    console.log("🚀 ~ file: userInfoForm.tsx ~ line 72 ~ EditUserInfo ~ getBanks= ~ res", res)
    try {
      if (res.status === 200) {
        const bankObj: { bankID: number } = res.banks.filter((bank: any) => this.props.info?.bankName === bank.bankName)[0]
        this.setState({ banks: res.banks, loadData: false, outboundData: false, bankInitialValue: bankObj ? bankObj.bankID : null }, () => {
          this.formRef.current!.setFieldsValue({ bankID: this.state.bankInitialValue })
        })
      } else {
        this.setState({ loadData: false, outboundData: false, errorMode: true })
      }
    } catch (error) {
      this.setState({ loadData: false, outboundData: false, errorMode: true })
    }
  }

  docValue = (docKey: string) => {
    const value = this.state.docs[docKey];
    if (typeof value === "string") return value;
    const uploaded = value.find((file: any) => file.originFileObj);
    return uploaded ? uploaded.originFileObj : (value[0]?.url ?? "");
  }

  isDocChanged = (docKey: string, storedUrl?: string) => this.docValue(docKey) !== (storedUrl || "")

  checkDocsChanged = () => {
    let updatedDocs: string[] = []
    const { info } = this.props;
    if (info) {
      if (this.isDocChanged("consent", info.consent?.[0])) {
        updatedDocs.push("consent")
      }
      if (this.isDocChanged("hrLetter", info.hrLetter?.[0])) {
        updatedDocs.push("hrLetter")
      }
      if (this.isDocChanged("nationalIdFront", info.nationalId?.[0]) || this.isDocChanged("nationalIdBack", info.nationalId?.[1])) {
        updatedDocs.push("nationalID")
      }
    }
    return updatedDocs;
  }

  updateUser = (values: any) => {
    const enteredMaxInstallments = values?.userMaxInstallments;
    const companyMax = this.props.info?.companyMaxInstallmentCount;
    const currentMaxInstallments = this.props.info?.userMaxInstallments;
    const hasEnteredMaxInstallments = enteredMaxInstallments !== undefined && enteredMaxInstallments !== null && enteredMaxInstallments !== '';
    const hasChangedMaxInstallments = hasEnteredMaxInstallments && Number(enteredMaxInstallments) !== Number(currentMaxInstallments);

    // Warn only when max installments was changed and exceeds the company's maximum
    if (hasChangedMaxInstallments && companyMax && Number(enteredMaxInstallments) > Number(companyMax)) {
      this.setState({ warningModalVisible: true, pendingValues: values });
      return;
    }

    this.proceedUpdate(values);
  };

  handleWarningCancel = () => this.setState({ warningModalVisible: false, pendingValues: null });

  handleWarningConfirm = () => {
    const pendingValues = this.state.pendingValues;
    this.setState({ warningModalVisible: false, pendingValues: null });
    if (pendingValues) this.proceedUpdate(pendingValues);
  };

  proceedUpdate = async (values: any) => {
    console.log("🚀 ~ file: userInfoForm.tsx ~ line 87 ~ EditUserInfo ~ updateUser= ~ values", values)
    this.setState({ sending: true });
    const data: any = {
      userID: this.props.info && this.props.info.userID,
      firstName: values?.firstName ?? this.props.info?.firstName,
      middleName: values?.middleName ?? this.props.info?.middleName,
      lastName: values?.lastName ?? this.props.info?.lastName,
      email: values?.email ?? this.props.info?.email,
      nationalIdNumber: values?.nationalId ?? this.props.info?.nationalIDNumber,
      phone: values?.phone ?? this.props.info?.phone,
      bankID: values?.bankID ?? this.props.info?.bankID,
      accountHolderName: values?.accountHolderName ?? this.props.info?.bankAccountHolderName,
      accountHolderNameEn: values?.accountHolderNameEn ?? this.props.info?.bankAccountHolderNameEn,
      accountNumber: values?.accountNumber ?? this.props.info?.bankAccountNumber,
      netSalary: values?.netSalary ?? this.props.info?.netSalary,
      nationalIdFront: this.docValue("nationalIdFront"),
      nationalIdBack: this.docValue("nationalIdBack"),
      consent: this.docValue("consent"),
      hrLetter: this.docValue("hrLetter"),
      staff_id: values?.staff_id ?? this.props.info?.staff_id,
      updatedDocs: this.checkDocsChanged().length > 0 ? this.checkDocsChanged() : [" "],
      hiringDate: values?.hiringDate ? helper.changeDateFormat(values.hiringDate) : '',
      jobTitle: values?.jobTitle ?? this.props.info?.jobTitle,
      departmentID: values?.departmentID ? values.departmentID : this.props.info?.department ? this.props.info?.department.id : null,
      companyBranchID: values?.companyBranchID && this.region === Region.EG ? values.companyBranchID : null,
      city: values?.city && this.region === Region.SE ? this.props.info?.city : null,
      probationPeriod: values?.userProbationPeriod && this.region === Region.SE ? values?.userProbationPeriod : null,
      userMaxInstallments: (values?.userMaxInstallments !== undefined && values?.userMaxInstallments !== null && values?.userMaxInstallments !== '')
        ? values.userMaxInstallments
        : null,
    };
    const formData = new FormData();
    Object.keys(data).map((key, _index) => {
      //append all data to Form data [used when we uploads files with data]
      formData.append(key, data[key]);
      return 0;
    });
    const updateUser = await this.props.patchApi(
      "/users/updateUserInfo",
      formData
    );
    const res = await updateUser.payload;
    try {
      if (res.status === 200) {
        this.setState({ sending: false });
        message.success(res.message, 4);
        if (this.props?.fromViewUserAction) {
          const bank: { bankName: string } | any = this.state.banks?.find((bank: any) => bank?.bankID === data?.bankID)
          const department = this.state.departments?.find((department: any) => department?.id === data?.departmentID)
          const companyBranch = this.state.companyBranches?.find((branch: any) => branch?.id === data?.companyBranchID)

          this.props.getDataInfo({
            ...this.props.info,
            ...data,
            nationalIDNumber: data?.nationalIdNumber,
            bankName: bank?.bankName,
            bankAccountHolderName: data?.accountHolderName,
            bankAccountHolderNameEn: data?.accountHolderNameEn,
            bankAccountNumber: data?.accountNumber,
            department,
            companyBranch
          });
          this.props.stepperMoving(1);
        } else {
          helper.resetAccountTableInStepper();
          this.props.stepperMoving(0);
        }
      } else {
        this.setState({ sending: false });
        message.error(res.message, 4);
      }
    } catch (error) {
      this.setState({ sending: false });
      message.error("Something went wrong, please try again", 4);
    }
    console.log(
      "🚀 ~ file: editUserInfo.tsx ~ line 59 ~ EditUserInfo ~ updateUser= ~ data",
      data
    );
    console.log(
      "🚀 ~ file: userInfoForm.tsx ~ line 62 ~ EditUserInfo ~ updateUser= ~ formData",
      formData
    );
  };


  handleDocChange = (docKey: string, info: any) => {
    const fileList = (info?.fileList ?? []).map((file: any) =>
      !file.url && file.originFileObj
        ? { ...file, url: URL.createObjectURL(file.originFileObj) }
        : file
    );
    this.setState((prev: any) => ({ docs: { ...prev.docs, [docKey]: fileList } }));
    return fileList;
  };

  renderDocument = (title: string, docKey: string) => (
    <DocumentUpload
      key={docKey}
      title={title}
      name={docKey}
      value={this.state.docs[docKey]}
      onChange={(info) => this.handleDocChange(docKey, info)}
    />
  );

  getCompanyDepartments = async () => {
    try {
      this.setState({ loadData: true })
      const departs: any = await helper.getDepartments({ companyID: this.props.info?.companyID })
      if (departs.data.status === 200) {
        this.setState({ loadData: false, departments: departs.data.departments })
      }
      else {
        this.setState({ loadData: false, errorMode: true })
      }
    }
    catch (error) {
      console.log("🚀 ~ file: userInfoForm.tsx:233 ~ EditUserInfo ~ getCompanyDepartments= ~ error:", error)
      this.setState({ loadData: false, errorMode: true })
    }
  }

  getCompanyBranches = async () => {
    try {
      this.setState({ loadData: true })
      const branches: any = await this.props.request({ url: getCompanyBranchesByCompanyIdApi + this.props.info?.companyID, method: "GET" })
      if (branches?.data?.status === 200) {
        this.setState({ loadData: false, companyBranches: branches?.data?.data })
      } else {
        this.setState({ loadData: false, errorMode: true })
      }
    }
    catch (error) {
      this.setState({ loadData: false, errorMode: true })
    }
  }


  render() {
    const { info } = this.props;
    const {
      sending,
      banks,
      bankInitialValue,
      departments,
      companyBranches,
    } = this.state;
    const validation: any = helper.regexValidation;
    const basicInfo = [
      {
        key: 'Name', value: <Row>
          <Col span="8">
            <Form.Item
              name="firstName"
              rules={[
                { required: true, message: "First name mandatory!" },
              ]}
              initialValue={info?.firstName}
            >
              <Input placeholder="Enter the first name" />
            </Form.Item>
          </Col>
          <Col span="8">
            <Form.Item
              name={"middleName"}
              rules={[
                ...(this.region === Region.EG ? [{
                  required: true,
                  message: "Group name is mandatory",
                }] : []),
              ]}
              initialValue={info?.middleName}
            >
              <Input placeholder="Enter the middle name" />
            </Form.Item>
          </Col>
          <Col span="8">
            <Form.Item
              name="lastName"
              rules={[
                { required: true, message: "lastName is mandatory!" },
              ]}
              initialValue={info?.lastName}
            >
              <Input placeholder="Enter the last name" />
            </Form.Item>
          </Col>
        </Row>
      },
      { key: 'Company', value: info?.companyName ? info?.companyName : "NA" },
      ...(companyBranches?.length > 0 && this.region === Region.EG ?
        [{
          key: 'Branch',
          value: (
            <Form.Item
              name="companyBranchID"
              initialValue={info?.companyBranchID ? info?.companyBranchID : null}
            >
              <Select style={{ width: '90%' }}
                placeholder="Select a branch name">
                {[{ id: null, name: 'Not sure', nameAr: 'غير متأكد' }, ...companyBranches]?.map((branch: any, key: number) => {
                  return <Option value={branch?.id} key={key}>{branch?.name}</Option>
                })}
              </Select>
            </Form.Item>
          )
        }] : []),
        ...(this.region === Region.SE ? [{
          key: 'City',
          value:<Form.Item
          name="city"
          rules={[
            // { required: true, message: "City field is mandatory!" },
            {
              pattern: helper.regexValidation.englishStringRegex,
              message: "City field is not valid",
            }
          ]}
        >
          <Input placeholder="Enter the City Name" />
        </Form.Item>
        }] : []),
      {
        key: 'Staff ID',
        value: <Form.Item
          name="staff_id"
          rules={[
            { required: true, message: "Staff Id is mandatory!" },
          ]}
          initialValue={info?.staff_id}
        >
          <Input placeholder="Enter the Staff Id" />
        </Form.Item>
      },
      {
        key: 'Job Title',
        value: <Form.Item
          name="jobTitle"
          initialValue={info?.jobTitle}
        >
          <Input placeholder="Enter the job title" />
        </Form.Item>
      },
      {
        key: 'Department',
        value: <Form.Item
          name="departmentID"
          initialValue={this.props.info?.department?.id}
          // rules={[{ required: true, message: 'Required' }]}
        >
          <Select style={{ width: '90%' }}
            placeholder="Select a department name">
            {Array.isArray(departments) && departments.map((department: any, key: number) => {
              return <Option value={department.id} key={key}>{department.nameEn}</Option>
            })}
          </Select>
        </Form.Item>
      },
      {
        key: 'Hiring Date',
        value: <Form.Item
          name="hiringDate"
          initialValue={info?.hiringDate ? moment(info?.hiringDate) : null}>
          <DatePicker placeholder="Enter the hiring date" style={{ width: '90%' }} />
        </Form.Item>
      },
      ...(this.region === Region.SE ? [{
        key: 'Probation Period',
        value: <Form.Item
        name="userProbationPeriod"
        initialValue={info?.userProbationPeriod}
        >
          <Input placeholder="Enter the probation period" /> 
        </Form.Item>
      }] : []),
      {
        key: 'Maximum Installments',
        value: <Form.Item
          name="userMaxInstallments"
          initialValue={info?.userMaxInstallments ? Number(info?.userMaxInstallments) : undefined}
          extra={info?.companyMaxInstallmentCount
            ? <span style={{ color: '#34a97b', fontWeight: 600, fontSize: 12 }}>Company max: {info?.companyMaxInstallmentCount}</span>
            : undefined}
          rules={[{ type: 'integer', min: 1, max: 15, message: 'Maximum Installments must be between 1 and 15' }]}
        >
          <InputNumber style={{ width: '90%' }} precision={0} placeholder="Leave empty to use company default" />
        </Form.Item>
      },
    ]

    const personalInfo = [
      {
        key: 'Phone',
        value: <Form.Item
          name={'phone'}
          rules={[
            { required: true, message: "Phone is mandatory" },
          ]}
          initialValue={info?.phone ? info?.phone : 'NA'}
        >
          <Input placeholder='Enter your phone ' style={{ width: '90%' }} />
        </Form.Item>
      },
      {
        key: 'Email',
        value: <Form.Item
          name="email"
          rules={[
            // { required: true, message: "Email is mandatory!" },
            {
              pattern: validation.email,
              message: "Email is not valid",
            },
          ]}
          initialValue={info?.email}
        >
          <Input placeholder="Enter the email" />
        </Form.Item>
      },
      {
        key: 'National ID',
        value: <Form.Item
          name="nationalId"
          /** info.nationalIDNumber.includes('null') ? 'NA' : info.nationalIDNumber */
          initialValue={info?.nationalIDNumber && info?.nationalIDNumber}
        >
          <Input placeholder="Enter the National Id" />
        </Form.Item>
      },
    ]

    const bankInfo = [
      {
        key: 'Bank Name',
        value: <Form.Item
          name="bankID"
          initialValue={bankInitialValue}
          rules={[{ required: true, message: 'Required' }]}
        >
          <Select style={{ width: '90%' }}
            placeholder="Select a bank name">
            {banks.map((bank: any, key: number) => {
              return <Option value={bank.bankID} key={key}>{bank.bankName}</Option>
            })}
          </Select>
        </Form.Item>
      },
      {
        key: 'Bank Account holder Name',
        value: <Form.Item
          name="accountHolderName"
          rules={[
            { required: true, message: "Account name is mandatory!" },
          ]}
          initialValue={info?.bankAccountHolderName}
        >
          <Input placeholder="Enter the account holder name" />
        </Form.Item>
      },
      {
        key: 'Bank Account holder Name (English)',
        value: <Form.Item
          name="accountHolderNameEn"
          rules={[
            { pattern: helper.regexValidation.englishRegex, message: 'Account name (English) must be in english' },
            { min: 3, message: `Account name (English) can't be less than 3 chars` },
            { max: 250, message: `Account name (English) can't be more than 250 chars` },
          ]}
          initialValue={info?.bankAccountHolderNameEn}
        >
          <Input placeholder="Enter the account holder name in english" />
        </Form.Item>
      },
      {
        key: 'Bank Account Number',
        value: <Form.Item
          name="accountNumber"
          rules={[
            { required: true, message: "Account number is mandatory!" },
          ]}
          initialValue={info?.bankAccountNumber}
        >
          <Input placeholder="Enter the account number" />
        </Form.Item>
      },
      // { key: 'Meeza Card Status', value:  },
    ]

    // const salaryInfo = [
    //   {
    //     key: 'Net Salary',
    //     value: <Form.Item
    //       name="netSalary"
    //       rules={[
    //         { required: true, message: "Net salary is mandatory!" },
    //       ]}
    //       initialValue={info?.netSalary ? info?.netSalary : ''}
    //     >
    //       <Input placeholder="Enter the net salary" />
    //     </Form.Item>
    //   }
    // ]

    const documents = [
      {
        key: '',
        value: (
          <div className="docUpload-list docUpload-list--grid">
            {this.renderDocument('Hr Letter', 'hrLetter')}
            {this.renderDocument('Consent', 'consent')}
            {this.renderDocument('Front of National ID', 'nationalIdFront')}
            {this.renderDocument('Back of National ID', 'nationalIdBack')}
          </div>
        )
      },
    ]
    return (
      <div className="user">
        <Form
          name="nest-messages"
          ref={this.formRef}
          onFinish={this.updateUser}
        >
          {info && (
            <>
              <Row>
                <Col span="24">
                  <UserInfoUI userData={basicInfo} activeKey={1} header={'Basic Information'} nonEditable={true} />
                </Col>
                <Col span="24">
                  <UserInfoUI userData={personalInfo} activeKey={2} header={'Personal Information'} nonEditable={true} />
                </Col>
                <Col span="24">
                  <UserInfoUI userData={bankInfo} activeKey={4} header={'Bank Information'} nonEditable={true} />
                </Col>
                {/* <Col span="24">
                  <UserInfoUI userData={salaryInfo} activeKey={5} header={'Salary Information'} nonEditable={true} />
                </Col> */}
                <Col span="24">
                  <UserInfoUI userData={documents} activeKey={6} header={'Required Documents'} nonEditable={true} />
                </Col>
              </Row>

              <Row>
                <Col className="colOfAssign" span="24">
                  <Form.Item style={{ marginTop: "30px", float: "right" }}>
                    <Button
                      className="updateUserBtn"
                      type="primary"
                      block
                      shape="round"
                      htmlType="submit"
                      loading={sending}
                      style={{ backgroundColor: "#7CC58F", borderColor: "#7CC58F" }}
                    >
                      Update
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </Form>

        <MaxInstallmentsWarningModal
          open={this.state.warningModalVisible}
          companyMax={info?.companyMaxInstallmentCount}
          onConfirm={this.handleWarningConfirm}
          onCancel={this.handleWarningCancel}
        />
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  info: state.actionsReducer.info,
  fromViewUserAction: state.actionsReducer.isViewUserAction,
  request: state.actionsReducer.request,
});
export default connect(mapStateToProps, { patchApi, stepperMoving, getApi, getDataInfo, request })(
  EditUserInfo
);
